<template>
  <div>
    <slot
      name="expand-button"
      v-bind="{ expanded, toggleExpanded }"
    >
      <div class="flex justify-end mb-4">
        <button
          :aria-expanded="expanded.toString()"
          data-test="expand-all-button"
          @click="toggleExpanded(!expanded)"
        >{{ buttonString }}</button>
      </div>
    </slot>
    <slot v-bind="{ expandables, trackToggle }" />
  </div>
</template>

<script>
export default {
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandables: {},
    }
  },
  computed: {
    buttonString() {
      return this.expanded ? 'Collapse All' : 'Expand All'
    },
    childrenCount() {
      return this?.$children?.length || 0
    },
  },
  watch: {
    expandables() {
      // Auto expand/collapse all if all children are expanded/collapsed
      const expandableValues = Object.values(this.expandables)
      if (expandableValues.length === this.childrenCount) {
        if (
          expandableValues.every((v) => v === expandableValues[0]) &&
          expandableValues[0] !== this.expanded
        ) {
          this.toggleExpanded(expandableValues[0])
        }
      }
    },
    expanded() {
      // Expand/collapse all children if parent is expanded/collapsed
      this.expandables = this.expanded
        ? Object.keys(this.expandables).reduce(
            (acc, key) => ({ ...acc, [key]: true }),
            {}
          )
        : {}
    },
  },
  methods: {
    toggleExpanded(expanded) {
      this.$emit('toggle', expanded)
    },
    trackToggle({ expandableId, expandableStatus }) {
      this.expandables = {
        ...this.expandables,
        [expandableId]: expandableStatus,
      }
    },
  },
}
</script>
